"use client";

import { ScrollReveal } from "@/components/ui/scroll-reveal";

export function SocialProof() {
  return (
    <section className="py-16 px-6 border-t border-white/[0.06]">
      <div className="max-w-4xl mx-auto">
        <ScrollReveal>
          <p className="text-center text-white/50 text-sm mb-2">
            Один экран вместо двух личных кабинетов
          </p>
          <div className="flex items-center justify-center gap-4">
            <span className="text-lg font-bold text-[#cb11ab]/70">Wildberries</span>
            <span className="text-white/20">+</span>
            <span className="text-lg font-bold text-[#005bff]/70">Ozon</span>
            <span className="text-white/20">=</span>
            <span className="text-lg font-bold text-white">MPUNIT</span>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
